export default "__VITE_ASSET__oEDpB1vj__"